<script setup lang="ts">
import { ref } from 'vue'

import {
  CommonIncidentId,
  VolleyballIncidentId,
} from '@collector/sportsapi-client-legacy'
import IncidentButton from '@mobile/views/Relation/Shared/IncidentButton/IncidentButton.vue'
import { useLiveViewBackground } from '@mobile/views/Relation/Shared/LiveView/useLiveViewBackground'
import PocketIncidents from '@mobile/views/Relation/Shared/PocketIncidents/PocketIncidents.vue'
import QueueBlockedOverlay from '@mobile/views/Relation/Shared/Popups/Queue/QueueBlockedOverlay.vue'
import { useEventInjections } from '@mobile/views/Relation/Shared/RelationDependencies/useEventInjections'
import { useSportConfiguration } from '@mobile/views/Relation/Shared/RelationSportCommonDependencies/useSportConfiguration'

import LiveViewCenterColumn from './LiveViewCenterColumn/LiveViewCenterColumn.vue'
import LiveViewHeader from './LiveViewHeader/LiveVueHeader.vue'
import LiveViewLeftColumn from './LiveViewLeftColumn/LiveViewLeftColumn.vue'
import LiveViewRightColumn from './LiveViewRightColumn/LiveViewRightColumn.vue'

const { probableEvent } = useEventInjections()
const { eventHeaderConfiguration } = useSportConfiguration()
const liveViewBackground = useLiveViewBackground(
  probableEvent,
  eventHeaderConfiguration,
)
const isPocketIncidentsMenuExpanded = ref(false)
</script>

<template>
  <div
    class="relative h-full overflow-hidden pt-1"
    :class="liveViewBackground"
  >
    <QueueBlockedOverlay />
    <div class="flex h-full flex-col">
      <LiveViewHeader />
      <div
        class="grid h-full gap-4 px-2 pt-1 pb-5 sm:overflow-y-auto"
        style="grid-template-columns: 0.3fr 1fr 0.3fr; grid-template-rows: 100%"
      >
        <LiveViewLeftColumn />
        <LiveViewCenterColumn />
        <LiveViewRightColumn />
      </div>

      <PocketIncidents
        :isExpanded="isPocketIncidentsMenuExpanded"
        :incidentIds="[
          CommonIncidentId.TechnicalProblems,
          VolleyballIncidentId.BreakDuringTheGame,
          VolleyballIncidentId.RepeatAction,
          CommonIncidentId.MatchResumed,
        ]"
        @toggle="isPocketIncidentsMenuExpanded = !isPocketIncidentsMenuExpanded"
        @incidentAddedToQueue="isPocketIncidentsMenuExpanded = false"
      >
        <IncidentButton
          :key="VolleyballIncidentId.YellowCard"
          class="w-full"
          :type="'horizontal'"
          :incidentId="VolleyballIncidentId.YellowCard"
          :size="'xl'"
          :color="'white'"
          :name="'Yellow Card'"
          @incidentHandled="
            isPocketIncidentsMenuExpanded = !isPocketIncidentsMenuExpanded
          "
        />
        <IncidentButton
          :key="VolleyballIncidentId.RedCard"
          class="w-full"
          :type="'horizontal'"
          :incidentId="VolleyballIncidentId.RedCard"
          :size="'xl'"
          :color="'white'"
          :name="'Red Card'"
          @incidentHandled="
            isPocketIncidentsMenuExpanded = !isPocketIncidentsMenuExpanded
          "
        />
      </PocketIncidents>
    </div>
  </div>
</template>
